import { render, staticRenderFns } from "./BasicButtonLong.vue?vue&type=template&id=918acb20&"
import script from "./BasicButtonLong.vue?vue&type=script&lang=js&"
export * from "./BasicButtonLong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports